export default __webpack_public_path__ + "static/media/7-mobile.1d08eb0c.png";